$( document ).ready(function() {

var productsAdded = 0;
let productArray = [];
$('.round-button').on('click', function() {
$('.totalprice_check').addClass('show_checkout-btn');
  var $copyWrapper = $(this).closest('.copy-wrapper');
  var $quantityButton = $copyWrapper.find('.quantity-button');
  var $parentWrapper = $(this).parents('.bundle-product-card');
    
  productArray.push($(this).data('variant'));
  
    var productTitle = $parentWrapper.find('.product-title').text();
    var productImage = $parentWrapper.find('.image-wrapper img').attr('srcset');
    var productPrice = $parentWrapper.find('.product-price').text();
    var quantity =  $parentWrapper.find('.quantity-button').html();
    
// Append the product image, title, and price to the bundle summary list
var productHtml = '<li>' +
                    '<img src="' + productImage + '" alt="Product Image">' +
                    '<div class="product-details">' +
                      '<span class="inr_product-title">' + productTitle + '</span>' +
                      '<span class="inr_product-price">' + productPrice + '</span>' +
                    '</div>' +
                  '<span class="inr_quantity">' + quantity + '</span>' +
                  '</li>';

$('.js-bundle-summary-list').append(productHtml);
    
    $('.bundle-summary-list-wrapper').removeAttr('hidden');
    
    productsAdded++;
    var remainingProducts = 4 - productsAdded;
    $('.add-bundle-to-cart-button').text('Pick ' + remainingProducts + ' products'); // Update button text
 
     if (remainingProducts == 0) {
        $('.add-bundle-to-cart-button').hide();
     }
    if (productsAdded >= 4) {
      $('.round-button').addClass('is-inactive').off('click'); // Disable add button
      $('form.bundle_cart').removeAttr('hidden');
    }
    calculateTotalPrice();
  });
  
function addToCartBundle(productArray) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
      'items': productArray.map(function(variantId) {
        return { 'id': variantId, 'quantity': 1 };
      })
    },
    success: function() {
      window.location.href="/checkout";
    },
     error: function(xhr, status, error) {
      let errtxt = JSON.parse(xhr.responseText)
      alert('Sorry, '+errtxt.description);
    }
   
  });
}
  
  // Event listener for form submission
$('form.bundle_cart').submit(function(event) {
  event.preventDefault(); // Prevent default form submission
  // Call addToCart function with productArray
  addToCartBundle(productArray);
});

// Bundle Quantity
      $(document).on("click", "button.plus-button", function() {
       $('button.minus-button').removeClass('removable');
        var inputField = $(this).siblings('.number-input');
       
        var currentValue = parseInt(inputField.val());
       
        var newValue = currentValue + 1;
        
        inputField.val(newValue);
        if (currentValue >= 3){
        $('.add-product-button').addClass('is-inactive');
        $('.plus-button').addClass('removable');
        }
        
        $('.add-bundle-to-cart-button').remove();
    });

    // Minus button click event
  $(document).on("click", "button.minus-button", function() {
  
        var inputField = $(this).siblings('.number-input');
        
        var currentValue = parseInt(inputField.val());
       if (currentValue === 0) {
        $(this).addClass('removable');
    }
     if (currentValue <= 4){
        $('.add-product-button').removeClass('is-inactive');
        }
        var newValue = currentValue > 0 ? currentValue - 1 : 0;
      
        inputField.val(newValue);
        
    });
  
// Reset Button
  
$(document).on("click", "button.reset-btn", function() {
      var nmbr = $('ul.bundle-summary-list li').remove();
       $('.add-product-button').removeClass('is-inactive');
        $('.add-bundle-to-cart-button').remove();
        $('.totalprice_check').remove();
          productsArray =[];
        location.reload();
    });

function calculateTotalPrice() {
    let totalPrice = 0;
    $('ul.bundle-summary-list.js-bundle-summary-list .inr_product-price').each(function(e) {
        let price = parseFloat($(this).text().replace("$",""));
        totalPrice += price;
    });
 
    $('.bundle-total-price').empty();
    $('.bundle-total-price').html('$' + totalPrice);
}

  $(document).on('click','.bundle-summary-list li',function(e) {
    let qty = $(this).find('.number-input').val();
    if (qty >= 4) {
        return; // Stop further processing if quantity is already 4 or more
    }
    let price = parseFloat($(this).find('.inr_product-price').text().replace('$',''));
    let newPrice = parseFloat(price) * parseInt(qty);
    $(this).find('.inr_product-price').html('$ '+newPrice);
    calculateTotalPrice();
});
  
});
